import { z } from 'zod';
/**
 * Colores admitidos para el chip de una etiqueta. Es la paleta de acentos que
 * ya usa el menú del CRM: así una etiqueta no puede pintarse de un color que no
 * existe en el tema claro o en el oscuro.
 */
export const CLIENT_TAG_COLORS = [
    'slate',
    'jr2',
    'sky',
    'emerald',
    'amber',
    'rose',
    'purple',
    'fuchsia',
    'teal',
];
/**
 * Normaliza el nombre para comparar: minúsculas, sin acentos y sin espacios
 * repetidos. Es lo que se guarda en `slug` y lo que hace que «Feria Madrid» y
 * «feria  madrid» sean la MISMA etiqueta — y por tanto el mismo segmento.
 */
export function clientTagSlug(name) {
    return name
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}
export const ClientTagDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    color: z.enum(CLIENT_TAG_COLORS),
    description: z.string().nullable(),
    /** Cuántos clientes vivos la llevan. Solo en el listado del catálogo. */
    clientCount: z.number().int().optional(),
});
export const ClientTagListResponseSchema = z.object({
    items: z.array(ClientTagDtoSchema),
});
export const CreateClientTagSchema = z.object({
    name: z.string().trim().min(1, 'La etiqueta necesita un nombre').max(60),
    color: z.enum(CLIENT_TAG_COLORS).default('slate'),
    description: z.string().trim().max(200).nullable().optional(),
});
export const UpdateClientTagSchema = CreateClientTagSchema.partial();
/**
 * Se manda la lista COMPLETA de etiquetas del cliente, no un añadir/quitar.
 * El editor de la ficha trabaja sobre el conjunto entero y así dos pestañas
 * abiertas no se pisan a medias: gana la última que guarda, y se ve.
 */
export const SetClientTagsSchema = z.object({
    tagIds: z.array(z.string().min(1)).max(50),
});
//# sourceMappingURL=client-tags.js.map